// import React, { useEffect, useState, useRef } from "react";
// import axios from "axios";
// import { Api } from "../Api/Api";

// export default function UploadPDF() {
//   const [file, setFile] = useState(null);
//   const [previewUrl, setPreviewUrl] = useState("");
//   const [uploads, setUploads] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const iframeRef = useRef(null);

//   useEffect(() => {
//     fetchUploads();
//     return () => {
//       if (previewUrl) URL.revokeObjectURL(previewUrl);
//     };
//   }, []);

//   const fetchUploads = async () => {
//     try {
//       const res = await axios.get(`${Api}pdf/get_uploaded.php`);
//       if (res.data.ok) setUploads(res.data.uploads || []);
//     } catch (e) {
//       console.error(e);
//     }
//   };

//   const handleFile = (e) => {
//     const f = e.target.files[0];
//     if (!f) return;
//     if (f.type !== "application/pdf") {
//       alert("Please upload a PDF file");
//       return;
//     }
//     setFile(f);
//     const url = URL.createObjectURL(f);
//     setPreviewUrl(url);
//   };

//   const handleUpload = async () => {
//     if (!file) {
//       alert("Select a PDF first");
//       return;
//     }
//     setLoading(true);
//     try {
//       const fd = new FormData();
//       fd.append("pdf", file);
//       const res = await axios.post(`${Api}pdf/upload.php`, fd, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });
//       if (res.data.ok) {
//         setFile(null);
//         setPreviewUrl("");
//         fetchUploads();
//         alert("Uploaded");
//       } else {
//         alert("Upload failed");
//       }
//     } catch (e) {
//       console.error(e);
//       alert("Upload error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Mark payment cleared (POST id)
//   const clearPayment = async (id) => {
//     if (!window.confirm("Mark payment cleared for this PDF?")) return;
//     try {
//       const res = await axios.post(`${Api}pdf/clear_payment.php`, { id });
//       if (res.data.ok) {
//         // remove from current uploads and refresh
//         setUploads((prev) => prev.filter((u) => u.id !== id));
//         alert("Marked cleared");
//       } else {
//         alert("Failed to mark cleared");
//       }
//     } catch (e) {
//       console.error(e);
//       alert("Error");
//     }
//   };

//   // share via WhatsApp (link to get_pdf.php)
//   const getWhatsAppLink = (row) => {
//     const serverUrl = `${Api}pdf/get_pdf.php?id=${row.id}`;
//     const text = encodeURIComponent(
//       `Invoice: ${row.original_name}\nView: ${serverUrl}`
//     );
//     return `https://wa.me/?text=${text}`;
//   };

//   return (
//     <div className="p-6 max-w-5xl mx-auto">
//       <h1 className="text-2xl font-semibold mb-4">Upload PDF / Invoice</h1>

//       <div className="mb-6 grid grid-cols-1 md:grid-cols-3 gap-4">
//         <div className="md:col-span-2">
//           <input
//             type="file"
//             accept="application/pdf"
//             onChange={handleFile}
//             className="mb-2"
//           />
//           <div className="flex space-x-2">
//             <button
//               onClick={handleUpload}
//               disabled={loading || !file}
//               className="px-4 py-2 bg-blue-600 text-white rounded disabled:opacity-50"
//             >
//               {loading ? "Uploading..." : "Upload"}
//             </button>
//             <button
//               onClick={() => {
//                 setFile(null);
//                 if (previewUrl) {
//                   URL.revokeObjectURL(previewUrl);
//                   setPreviewUrl("");
//                 }
//               }}
//               className="px-4 py-2 bg-gray-300 rounded"
//             >
//               Clear
//             </button>
//           </div>

//           <div className="mt-4 border rounded p-2">
//             {previewUrl ? (
//               <object
//                 data={previewUrl}
//                 type="application/pdf"
//                 width="100%"
//                 height="500"
//               >
//                 <p>
//                   PDF preview not supported.{" "}
//                   <a href={previewUrl} target="_blank" rel="noreferrer">
//                     Open in new tab
//                   </a>
//                 </p>
//               </object>
//             ) : (
//               <div className="text-gray-500">No PDF selected for preview</div>
//             )}
//           </div>
//         </div>

//         <div className="border rounded p-4">
//           <h3 className="font-medium mb-2">Recent Uploads</h3>
//           <div className="space-y-3 max-h-[420px] overflow-auto">
//             {uploads.length === 0 && (
//               <div className="text-sm text-gray-500">No uploads</div>
//             )}
//             {uploads.map((row) => {
//               const serverUrl = `${Api}pdf/get_pdf.php?id=${row.id}`;

//               const handleDownload = async () => {
//                 try {
//                   const res = await axios.get(serverUrl, {
//                     responseType: "blob", // get file as Blob
//                   });
//                   const blob = new Blob([res.data], {
//                     type: "application/pdf",
//                   });
//                   const url = window.URL.createObjectURL(blob);

//                   const link = document.createElement("a");
//                   link.href = url;
//                   link.download = row.original_name || "invoice.pdf"; // filename
//                   document.body.appendChild(link);
//                   link.click();
//                   document.body.removeChild(link);

//                   window.URL.revokeObjectURL(url); // cleanup
//                 } catch (err) {
//                   console.error("Download failed:", err);
//                   alert("Failed to download PDF");
//                 }
//               };

//               return (
//                 <div
//                   key={row.id}
//                   className="p-2 border rounded bg-white flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3"
//                 >
//                   {/* File Info */}
//                   <div>
//                     <div className="font-semibold">{row.original_name}</div>
//                     <div className="text-xs text-gray-500">
//                       {new Date(row.uploaded_at).toLocaleString()}
//                     </div>
//                   </div>

//                   {/* Action Buttons */}
//                   <div className="flex flex-wrap gap-2 justify-end">
//                     <a
//                       href={serverUrl}
//                       target="_blank"
//                       rel="noreferrer"
//                       className="px-3 py-1 text-sm bg-blue-600 text-white rounded"
//                     >
//                       View
//                     </a>

//                     <button
//                       onClick={handleDownload}
//                       className="px-3 py-1 text-sm bg-purple-600 text-white rounded"
//                     >
//                       Download
//                     </button>

//                     <button
//                       onClick={() => clearPayment(row.id)}
//                       className="px-3 py-1 text-sm bg-green-600 text-white rounded"
//                     >
//                       Payment Clear
//                     </button>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Api } from "../Api/Api";

export default function UploadPDF() {
  const [file, setFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState("");
  const [uploads, setUploads] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchUploads();
    return () => {
      if (previewUrl) URL.revokeObjectURL(previewUrl);
    };
  }, []);

  const fetchUploads = async () => {
    try {
      const res = await axios.get(`${Api}pdf/get_uploaded.php`);
      if (res.data.ok) setUploads(res.data.uploads || []);
    } catch (e) {
      console.error(e);
    }
  };

  const handleFile = (e) => {
    const f = e.target.files[0];
    if (!f) return;
    if (f.type !== "application/pdf") {
      Swal.fire("Error", "Please upload a PDF file", "error");
      return;
    }
    setFile(f);
    const url = URL.createObjectURL(f);
    setPreviewUrl(url);
  };

  const handleUpload = async () => {
    if (!file) {
      Swal.fire("Error", "Select a PDF first", "error");
      return;
    }
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("pdf", file);
      const res = await axios.post(`${Api}pdf/upload.php`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (res.data.ok) {
        setFile(null);
        setPreviewUrl("");
        fetchUploads();
        Swal.fire("Success", "PDF uploaded successfully", "success");
      } else {
        Swal.fire("Error", "Upload failed", "error");
      }
    } catch (e) {
      console.error(e);
      Swal.fire("Error", "Upload error", "error");
    } finally {
      setLoading(false);
    }
  };

  const clearPayment = async (id) => {
    const result = await Swal.fire({
      title: "Mark Payment Cleared?",
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, clear it",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      try {
        const res = await axios.post(`${Api}pdf/clear_payment.php`, { id });
        if (res.data.ok) {
          setUploads((prev) => prev.filter((u) => u.id !== id));
          Swal.fire("Cleared!", "Payment has been marked cleared", "success");
        } else {
          Swal.fire("Error", "Failed to mark cleared", "error");
        }
      } catch (e) {
        console.error(e);
        Swal.fire("Error", "Something went wrong", "error");
      }
    }
  };

  const getWhatsAppLink = (row) => {
    const serverUrl = `${Api}pdf/get_pdf.php?id=${row.id}`;
    const text = encodeURIComponent(
      `Invoice: ${row.original_name}\nView: ${serverUrl}`
    );
    return `https://wa.me/?text=${text}`;
  };

  return (
    <div className="p-4 max-w-4xl mx-auto">
      <h1 className="text-2xl font-semibold mb-4">Upload PDF / Invoice</h1>

      <div className="mb-6 flex flex-col md:flex-row gap-4">
        {/* Upload Section */}
        <div className="flex-1">
          <input
            type="file"
            accept="application/pdf"
            onChange={handleFile}
            className="mb-2 w-full"
          />
          <div className="flex flex-wrap gap-2 mb-4">
            <button
              onClick={handleUpload}
              disabled={loading || !file}
              className="px-4 py-2 bg-blue-600 text-white rounded disabled:opacity-50 flex-1"
            >
              {loading ? "Uploading..." : "Upload"}
            </button>
            <button
              onClick={() => {
                setFile(null);
                if (previewUrl) URL.revokeObjectURL(previewUrl);
                setPreviewUrl("");
              }}
              className="px-4 py-2 bg-gray-300 rounded flex-1"
            >
              Clear
            </button>
          </div>

          <div className="border rounded p-2">
            {previewUrl ? (
              <object
                data={previewUrl}
                type="application/pdf"
                width="100%"
                height="400"
              >
                <p>
                  PDF preview not supported.{" "}
                  <a href={previewUrl} target="_blank" rel="noreferrer">
                    Open in new tab
                  </a>
                </p>
              </object>
            ) : (
              <div className="text-gray-500 text-center py-20">
                No PDF selected for preview
              </div>
            )}
          </div>
        </div>

        {/* Recent Uploads */}
        <div className="w-full md:w-1/3 border rounded p-4 overflow-auto max-h-[500px]">
          <h3 className="font-medium mb-2">Recent Uploads</h3>
          <div className="space-y-3">
            {uploads.length === 0 && (
              <div className="text-sm text-gray-500">No uploads</div>
            )}
            {uploads.map((row) => {
              const serverUrl = `${Api}pdf/get_pdf.php?id=${row.id}`;

              const handleDownload = async () => {
                try {
                  const res = await axios.get(serverUrl, {
                    responseType: "blob",
                  });
                  const blob = new Blob([res.data], {
                    type: "application/pdf",
                  });
                  const url = window.URL.createObjectURL(blob);

                  const link = document.createElement("a");
                  link.href = url;
                  link.download = row.original_name || "invoice.pdf";
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);

                  window.URL.revokeObjectURL(url);
                } catch (err) {
                  console.error("Download failed:", err);
                  Swal.fire("Error", "Failed to download PDF", "error");
                }
              };

              return (
                <div
                  key={row.id}
                  className="p-2 border rounded bg-white flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2"
                >
                  <div>
                    <div className="font-semibold">{row.original_name}</div>
                    <div className="text-xs text-gray-500">
                      {new Date(row.uploaded_at).toLocaleString()}
                    </div>
                  </div>

                  <div className="flex flex-wrap gap-2 mt-2 sm:mt-0">
                    <a
                      href={serverUrl}
                      target="_blank"
                      rel="noreferrer"
                      className="px-2 py-1 text-sm bg-blue-600 text-white rounded"
                    >
                      View
                    </a>
                    <button
                      onClick={handleDownload}
                      className="px-2 py-1 text-sm bg-purple-600 text-white rounded"
                    >
                      Download
                    </button>
                    <button
                      onClick={() => clearPayment(row.id)}
                      className="px-2 py-1 text-sm bg-green-600 text-white rounded"
                    >
                      Payment Clear
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
